/* eslint-disable prettier/prettier */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DynamicComponent from '../Components/DynamicComponent';
import 'react-tooltip/dist/react-tooltip.css';


//PandoNexis: BEGIN IMPORT
import GtmTracker from '../_Addons/PNGtmEnhancedEcom/GtmTracker';
//PandoNexis: END IMPORT

import './pn.events.js';
import './pn.functions.js';

const renderReact = (element, container, callback) => {
    window.__pn.registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

window.__pn = {
    ...window.__pn,
    initNewBuyButton: (button, buyButtonComponent = null) => {
        initNewBuyButton(button, buyButtonComponent = null);
    },
    cache: {}, // for storing cache data for current request
};
const initNewBuyButton = (button, buyButtonComponent = null) => {
    const BuyButton = buyButtonComponent ? buyButtonComponent : DynamicComponent({
        loader: () => import('../_PandoNexis/Components/BuyButton'),
    });

    const {
        articleNumber,
        quantityFieldId,
        href,
        cssClass,
        label,
        gtmTrackingData,

        // START ProductConfigurator
        showPreInfo,
        showPostInfo,
        preInfoType,
        preInfoModal,
        postInfoModal,
        // END ProductConfigurator
    } = button.dataset;
    renderReact(
        <Provider store={window.__pn.store}>
            <BuyButton
                {...{
                    label,
                    articleNumber,
                    quantityFieldId,
                    href,
                    cssClass,
                    gtmTrackingData,
                    // START ProductConfigurator
                    showPreInfo,
                    showPostInfo,
                    preInfoType,
                    preInfoModal,
                    postInfoModal,
                    // END ProductConfigurator
                }}
            />
        </Provider>,
        button
    );
};

export const bootstrapPNComponents = () => {
    // PandoNexis GeneralComponents

    const buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/BuyButton'), // import('../Components/BuyButton'),
        });
        Array.from(buyButtons).forEach(
            (button) => {
                initNewBuyButton(button, BuyButton);
            }
        );
    }

    // PRODUCT PAGE IMAGES
    const lightBoxImagesEl = document.getElementById('lightBoxImages');
    if (lightBoxImagesEl) {
        const { flags } = lightBoxImagesEl?.dataset || '';
        const LightboxImages = DynamicComponent({
            loader: () => import('../_Solution/Components/LightboxImages'),
        });
        import('../Reducers/LightboxImages.reducer').then(
            ({ lightboxImages }) => {
                window.__pn.store.injectReducer('lightboxImages', lightboxImages);
                const rootElement = lightBoxImagesEl;
                const images = Array.from(
                    rootElement.querySelectorAll('template')
                ).map((img) => ({
                    html: img.innerHTML,
                    src: img.dataset.src,
                    type: img.dataset.type,
                    videoSrc: img.dataset.videoSrc,
                    title: img.dataset.title,
                }));
                renderReact(
                    <Provider store={window.__pn.store}>
                        <LightboxImages images={images} flags={flags?.split('|') || []} />
                    </Provider>,
                    lightBoxImagesEl
                );
            }
        );
    }
    // END PRODUCT PAGE IMAGES

    // ICONS
    const iconEls = document.querySelectorAll('.pn-icon');
    if (iconEls) {
        const PnIcon = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/PnIcon'),
        });
        iconEls.forEach((elem) => {
            const { iconName, title, width, height } = elem.dataset;
            ReactDOM.render(
                <Provider store={window.__pn.store}>
                    <PnIcon iconName={iconName} title={title} width={width} height={height} />
                </Provider>,
                elem
            );
        });
    }

    // Modal login
    let modalLoginEl = document.getElementById('modalLogin');
    if (!modalLoginEl) {
        modalLoginEl = document.createElement('div');
        modalLoginEl.id = 'modalLogin';
        document.querySelector('body').append(modalLoginEl);
    }
    if (modalLoginEl) {
        const ModalLogin = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/ModalLogin'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <ModalLogin />
            </Provider>,
            modalLoginEl
        );
    }
    //  END Modal login

    // Generic loader

    // ASPEN: 2025-02-11: Denna utkommenterade komponenter ska l�ggas till efter merge fr�n Blueprint
    // ************************************************************************************************
    //const loaderId = 'genericLoader';
    //let loaderEl = document.getElementById(loaderId);
    //if (!loaderEl) {
    //    loaderEl = document.createElement('div');
    //    loaderEl.id = loaderId;
    //    document.querySelector('body').append(loaderEl);
    //}
    //if (loaderEl) {
    //    const GenericLoader = DynamicComponent({
    //        loader: () => import('../_PandoNexis/Components/GenericLoader'),
    //    });
    //    renderReact(
    //        <Provider store={window.__pn.store}>
    //            <GenericLoader />
    //        </Provider>,
    //        loaderEl
    //    );
    //}
    // Generic loader
    const loaderId = 'genericLoader';
    let loaderEl = document.getElementById(loaderId);
    if (!loaderEl) {
        loaderEl = document.createElement('div');
        loaderEl.id = loaderId;
        document.querySelector('body').append(loaderEl);
    }
    if (loaderEl) {
        const GenericLoader = DynamicComponent({
            loader: () => import('../_PandoNexis/Components/GenericLoader'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <GenericLoader />
            </Provider>,
            loaderEl
        );
    }

    // END PandoNexis GeneralComponents


 
    // ADDONS
    //PandoNexis: BEGIN  COMPONENT

    //// 3D Background
    //const threeDBg = document.getElementById("pnMainBackground");
    //if (threeDBg) {
    //    const ThreeDBg = DynamicComponent({
    //        loader: () => import('../_Addons/PNMovingBg/Background'),
    //    });
    //    renderReact(
    //        <Provider store={window.__pn.store}>
    //            <ThreeDBg />
    //        </Provider>,
    //        threeDBg
    //    );
    //}
    //// END 3D Background

    // Mini Cart Extended (Off-canvas)

    const miniCartExtended = document.getElementById('PNMiniCartExtended');
    if (miniCartExtended) {
        const MiniCartExtendedContainer = DynamicComponent({
            loader: () => import('../_Addons/PNMiniCartExtended/Components/MiniCartExtendedContainer'),
        });
        const { isInCheckout, showInfo } = miniCartExtended.dataset || 'false';

        ReactDOM.render(
            <Provider store={window.__pn.store}>
                <MiniCartExtendedContainer
                    isInCheckout={isInCheckout === 'true'}
                    showInfo={showInfo}
                />
            </Provider>,
            miniCartExtended
        );
    }
    // END Mini Cart Extended (Off-canvas)

    //// Logged on info
    //const loggedOnInfoLabels = document.querySelectorAll('.pn-info-label');
    //if (loggedOnInfoLabels) {
    //    const LoggedOnInfoLabel = DynamicComponent({
    //        loader: () => import('../_Addons/PNLoggedOnInfoLabel/Components/LoggedOnInfoLabelContainer'),
    //    });

    //    loggedOnInfoLabels.forEach((elem, index) => {
    //        const { heading } = elem.dataset;
    //        renderReact(
    //            <Provider store={window.__pn.store}>
    //                <LoggedOnInfoLabel getData={index === 0} heading={heading || ''} />
    //            </Provider>,
    //            elem
    //        );
    //    });
    //}
    //// END Logged on info

    //// MediaCatalog
    //const mediaCatalog = document.getElementById("media-catalog");
    //if (mediaCatalog) {
    //    const MediaCatalog = DynamicComponent({
    //        loader: () => import('../_Addons/PNMediaCatalog/Components/MediaCatalogContainer'),
    //    });
    //    const { mediaFolderId, mediaFolderAlternativeName, mediaFolderAlternativeView } = mediaCatalog.dataset;
    //    const useAltMediaView = mediaFolderAlternativeView?.toLowerCase() === 'true';
    //    renderReact(
    //        <Provider store={window.__pn.store}>
    //            <MediaCatalog mediaFolderId={mediaFolderId} alternativeFolderName={mediaFolderAlternativeName} useAltMediaView={useAltMediaView} />
    //        </Provider>,
    //        mediaCatalog
    //    );
    //}
    //// END MediaCatalog

    //// OrganizationSelector
    //const organizationSelectors = document.querySelectorAll(".pn-organization-selector");
    //if (organizationSelectors) {

    //    const OrganizationSelector = DynamicComponent({
    //        loader: () => import('../_Addons/PNOrganizationSelector/Components/OrganizationSelectorContainer'),
    //    });
    //    Array.from(organizationSelectors).forEach(
    //        (organizationSelector) => {
    //            renderReact(
    //                <Provider store={window.__pn.store}>
    //                    <OrganizationSelector />
    //                </Provider>,
    //                organizationSelector
    //            );
    //        });
    //}
    //// END OrganizationSelector

    // Show Infinite scroll Button
    const infiniteScrollButton = document.getElementById("InfiniteScroll");
    if (infiniteScrollButton) {
        const InfiniteScrollButton = DynamicComponent({
            loader: () => import('../_Addons/PNInfiniteScroll/Components/InfiniteScrollButtonContainer'),
        });
        const { elementQs, totalPages, totalCount, currentPageIndex, pageSize, url, scrollType } = infiniteScrollButton.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <InfiniteScrollButton {...{ elementQs, url, scrollType }} totalPages={parseInt(totalPages)} totalCount={parseInt(totalCount)} currentPageIndex={parseInt(currentPageIndex)} pageSize={parseInt(pageSize)} />
            </Provider>,
            infiniteScrollButton
        );
    }
    // END Show Infinite Scroll Button

    //// PNGenericForm
    ////const pnGenericForm = document.getElementById("PNGenericForm");
    //const pnGenericForm = document.querySelectorAll(".pn-form");
    //if (pnGenericForm) {
    //    const PNGenericForm = DynamicComponent({
    //        loader: () => import('../_Addons/PNGenericForm/Components/PNGenericFormContainer'),
    //    });
    //    pnGenericForm.forEach((elem, index) => {

    //        const { page } = elem.dataset;
    //        renderReact(
    //            <Provider store={window.__pn.store}>
    //                <PNGenericForm {...{ page }} />
    //            </Provider>,
    //            elem
    //        );

    //    });
    //}
    //// END PNGenericForm

    // CollectionPage
    const collectionPage = document.getElementById("collectionPage");
    if (collectionPage) {
        const CollectionPage = DynamicComponent({
            loader: () => import('../_Addons/PNCollectionPage/Components/CollectionPageContainer'),
        });

        const { collectionPageSystemId, link, linkText } = collectionPage.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <CollectionPage {...{ collectionPageSystemId, link, linkText }} />
            </Provider>,
            collectionPage
        );
    }
    // END CollectionPage

    //// PNGenericDataView
    //const pnGenericDataView = document.querySelectorAll(".generic-data-view__data");

    //if (pnGenericDataView) {
    //    const PNGenericDataViewContainer = DynamicComponent({
    //        loader: () => import('../_Addons/PNGenericDataView/Components/PNGenericDataView.container'),
    //    });
    //    const calculateTableTop = () => {
    //        const gdvTable = document.querySelector(
    //            '.generic-data-view__wrapper'
    //        );
    //        let footerHeight = 0;
    //        if (gdvTable) {
    //            const viewportOffset = gdvTable.getBoundingClientRect();
    //            const top = viewportOffset.top;

    //            const footerEl = document.querySelector('footer.footer');

    //            if (footerEl) {
    //                const footerOffset = footerEl.getBoundingClientRect();
    //                footerHeight = footerOffset.height;
    //                if (footerHeight > 0) {
    //                    footerHeight += 32;
    //                }
    //            }

    //           gdvTable.style.maxHeight =
    //                'calc(100vh - ' + (top + footerHeight + 56) + 'px)';
    //        }
    //    };

    //    if (PNGenericDataViewContainer) {
    //        pnGenericDataView.forEach((elem, index) => {

    //            const { appendToQuerySelector, page, viewTypes, dataType } = elem.dataset;
    //            renderReact(
    //                <Provider store={window.__pn.store}>
    //                    <PNGenericDataViewContainer pageSystemId={page} {...{ viewTypes, dataType }}
    //                        calculateTableTop={calculateTableTop} />
    //                </Provider>,
    //                elem
    //            );
    //        });
    //    }

    //    const debounce = (func, wait) => {
    //        let timeout;
    //        return (...args) => {
    //            clearTimeout(timeout);
    //            timeout = setTimeout(() => func(...args), wait);
    //        };
    //    };

    //    window.addEventListener('resize', debounce(calculateTableTop, 200));
    //}
    //// END PNGenericDataView

    // PNOrganizationsMapPage

    // PNCookieConsent
    const CookieConsentEl = document.getElementById('cookieConsent');
    if (CookieConsentEl) {
        const CookieConsent = DynamicComponent({
            loader: () => import('../_Addons/PNCookieConsent/Components/CookieConsent')
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <CookieConsent {...{ cookiebarVisible: true }} />
            </Provider>,
            CookieConsentEl
        )
    }

    const cookieSettingsButton = document.getElementById('cookieSettingsButton');
    if (cookieSettingsButton) {
        const CookieSettings = DynamicComponent({
            loader: () => import('../_Addons/PNCookieConsent/Components/CookieConsent')
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <CookieSettings {...{ showButton: true }} />
            </Provider>,
            cookieSettingsButton
        )
    }
    // END PNCookieConsent

    //// Organization page (Map, filters, info)
    //const organizationInfoEl = document.getElementById('organizationsMapInfo');
    //if (organizationInfoEl) {
    //    const OrganizationsMapInfoContainer = DynamicComponent({
    //        loader: () => import('../_Addons/PNOrganizationsMapPage/Components/OrganizationsMapInfoContainer'),
    //    });
    //    renderReact(
    //        <Provider store={window.__pn.store}>
    //            <OrganizationsMapInfoContainer />
    //        </Provider>,
    //        organizationInfoEl
    //    );
    //}
    //// END PNOrganizationsMapPage

    // PNHeaderUSPs
    // Fade in-out header-USPs
    const uspsEl = document.querySelector(".pn-header__header-usps");

    if (uspsEl) {
        const paragraps = uspsEl.querySelectorAll("p");
        if (paragraps) {
            const pCount = paragraps.length;
            if (pCount > 0) {
                const activeClass = "active";
                paragraps[0].classList.add(activeClass);

                if (paragraps.length > 1) {
                    let currentIndex = 0;
                    const uspInterval = setInterval(() => {
                        paragraps[currentIndex++].classList.remove(activeClass);
                        if (pCount == currentIndex) {
                            currentIndex = 0;
                        }
                        paragraps[currentIndex].classList.add(activeClass);
                    }, 4500);
                }
            }
        }
    }
    // END PNHeaderUSPs

    // PNNewsletterSignup
    // Newletter signup top be places anywhere
    const newsletterSignupEls = document.querySelectorAll(".pn-newsletter-signup");
   
    if (newsletterSignupEls) {
        const PnNewsletterSignup = DynamicComponent({
            loader: () => import('../_Addons/PNNewsletterSignup/Components/NewsletterSignupContainer'),
        });
        newsletterSignupEls.forEach((elem) => {
            const { placement } = elem.dataset;
            ReactDOM.render(
                <Provider store={window.__pn.store}>
                    <PnNewsletterSignup placement={placement} />
                </Provider>,
                elem
            );
        });
    }
    // END PNNewsletterSignup

    // Checkout page
    const checkoutEl = document.getElementById('checkout');
    if (checkoutEl) {
        const Checkout = DynamicComponent({
            loader: () => import('../_Addons/PNCheckoutExtended/Components/Checkout'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <Checkout />
            </Provider>,
            checkoutEl
        );
    }
    // END Checkout page

    // Mosaic Image gallery
    const mosaicImageGalleryEls = document.querySelectorAll('.pn-mosaic-image-gallery');
    if (mosaicImageGalleryEls) {

        const MosaicCardGallery = DynamicComponent({
            loader: () => import('../_Addons/PNImageGalleryMosaic/Components/ImageGalleryContainer'),
        });

        Array.from(mosaicImageGalleryEls).forEach(
            (mosaicImageGalleryEl) => {

                const { type, showFrame, gap } = mosaicImageGalleryEl.dataset;
                renderReact(
                    <Provider store={window.__pn.store}>
                        <MosaicCardGallery type={type} showFrame={showFrame !== undefined} gap={gap} childElements={mosaicImageGalleryEl.innerHTML} />
                    </Provider>,
                    mosaicImageGalleryEl
                );

            });
    }
    // END Mosaic Image gallery

    //// Product configurator
    //const productConfiguratorEl = document.getElementById('productConfigurator');
    //if (productConfiguratorEl) {
    //    const ProductConfig = DynamicComponent({
    //        loader: () => import('../_Addons/PNProductConfigurator/Components/ProductConfiguratorContainer'),
    //    });
    //    const { articleNo } = productConfiguratorEl.dataset;
    //    renderReact(
    //        <Provider store={window.__pn.store}>
    //            <ProductConfig {...{ articleNo }} />
    //        </Provider>,
    //        productConfiguratorEl
    //    );
    //}
    //// END Product configurator


    // BEGIN PNEnhancedEcom
    // add new element
    const gtmEnhancedEcomListener = document.createElement('div');
    const GtmEnhancedEcomListener = DynamicComponent({
        loader: () => import('../_Addons/PNGtmEnhancedEcom/GtmEnhancedEcomListener'),
    });

    ReactDOM.render(
        <Provider store={window.__pn.store}>
            <GtmEnhancedEcomListener />
        </Provider>,
        gtmEnhancedEcomListener
    );

    window.gtmTracker = new GtmTracker();
    document.addEventListener('click', (event) => {
        var gtmClickTracking;
        const node = event.target;
        if (node && node.matches('.gtm-productclick')) {
            gtmClickTracking = node.getAttribute('data-gtmclicktracking');
        }
        if (event.target?.parentNode) {
            const parentNode = event.target.parentNode;
            if (parentNode.matches('.gtm-productclick')) {
                gtmClickTracking = parentNode.getAttribute('data-gtmclicktracking');
            }
        }
        if (gtmClickTracking != null) {
            window.gtmTracker.click(gtmClickTracking);
        }
    }, false);

    window.addEventListener('load',
        () => {
            var prodBlock = document.querySelectorAll('.gtm-productimpression');
            if (prodBlock) {
                const prodBlockLength = prodBlock.length;
                for (var j = 0; j < prodBlockLength; j++) {
                    var impressionTracking = prodBlock[j].getAttribute('data-gtmimpressiontracking');
                    if (impressionTracking.length === 0) continue;

                    window.gtmTracker.impressions(JSON.parse(impressionTracking));
                }
            }
        });
    // END PNEnhancedEcom


    // PandoNexis: END COMPONENT



}